import { render, staticRenderFns } from "./file-table-item.vue?vue&type=template&id=cd318180&scoped=true"
import script from "./file-table-item.vue?vue&type=script&lang=js"
export * from "./file-table-item.vue?vue&type=script&lang=js"
import style0 from "./file-table-item.vue?vue&type=style&index=0&id=cd318180&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd318180",
  null
  
)

export default component.exports